function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { useProgress } from '../../useProgress';
import { propsSpinner } from './constants';
import { ContainerElement, BaseCircle, ProgressbarCircle } from './ProgressCircle.style';
export var ProgressCircle = _ref => {
  var {
    progress = 0,
    size = 'small'
  } = _ref;
  var {
    handleStrokeDasharray
  } = useProgress();
  return /*#__PURE__*/React.createElement(ContainerElement, {
    size: size,
    role: "progressbar"
  }, /*#__PURE__*/React.createElement(BaseCircle, propsSpinner[size]), /*#__PURE__*/React.createElement(ProgressbarCircle, _extends({}, propsSpinner[size], {
    strokeDashoffset: handleStrokeDasharray(progress, propsSpinner[size].strokeDasharray)
  })));
};
//# sourceMappingURL=ProgressCircle.js.map